<script setup lang="ts">
import {
  DropdownMenuArrow,
  DropdownMenuContent,
  DropdownMenuPortal,
  DropdownMenuRoot,
  DropdownMenuTrigger,
} from 'radix-vue'
import { ref } from 'vue'

type Align = 'start' | 'center' | 'end'
type Side = 'top' | 'right' | 'bottom' | 'left'

interface Props {
  align?: Align
  side?: Side
  showArrow?: boolean
}

withDefaults(defineProps<Props>(), {
  align: 'start',
  side: 'bottom',
  showArrow: false,
})

const open = ref(false)

function close() {
  open.value = false
}
</script>

<template>
  <DropdownMenuRoot v-model:open="open">
    <DropdownMenuTrigger as="template">
      <slot name="trigger" />
    </DropdownMenuTrigger>

    <DropdownMenuPortal to="#app-root">
      <DropdownMenuContent
        class="min-w-[12rem] w-max z-50 antialiased overflow-hidden rounded-md border shadow-md border-gray-200 dark:border-gray-700 text-gray-900 dark:text-gray-100 bg-white dark:bg-gray-800
               will-change-[transform,opacity] 
               data-[state=closed]:animate-hide 
               data-[side=bottom]:animate-slideDownAndFade 
               data-[side=left]:animate-slideLeftAndFade 
               data-[side=right]:animate-slideRightAndFade 
               data-[side=top]:animate-slideUpAndFade"
        :side-offset="5"
        :side="side"
        :align="align"
        :align-offset="0"
      >
        <slot :close="close" />
        <DropdownMenuArrow v-if="showArrow" />
      </DropdownMenuContent>
    </DropdownMenuPortal>
  </DropdownMenuRoot>
</template>
